'use strict'

module.exports =

  set: ->
    nextHref = document.querySelector("ul.pagination-links li.selected")?.nextElementSibling?.querySelector('a')?.getAttribute('href')
    prevHref = document.querySelector("ul.pagination-links li.selected")?.previousElementSibling?.querySelector('a')?.getAttribute('href')
    if nextHref
      @linkNext = @_setLink(nextHref, @linkNext, "next")
    else if @linkNext
      @linkNext.remove()
    if prevHref
      @linkPrev = @_setLink(prevHref, @linkPrev, "prev")
    else if @linkPrev
      @linkPrev.remove()

  _setLink: (href, oldLink, relValue) ->
    host = window.location.protocol + '//' + window.location.hostname
    linkNode = document.createElement("link")
    linkNode.href = "#{host}#{href}"
    linkNode.rel = relValue
    oldLink?.parentNode?.removeChild(oldLink)
    document.querySelector('head').appendChild(linkNode)
    return linkNode
